import React, { createContext, useCallback, useContext, useMemo } from 'react';
import { useAppResources } from './AppResourcesContext';
import { useUserProfile } from './UserProfileContext';

const StellineContext = createContext(null);

const isObject = (value) => value != null && typeof value === 'object' && !Array.isArray(value);

export const useStelline = () => {
  const context = useContext(StellineContext);
  if (!context) {
    return {
      stelline: null,
      stellineBalance: 0,
      isLoading: false,
      setStellineData: () => {},
    };
  }
  return context;
};

export const StellineProvider = ({ children }) => {
  const { appResources, updateAppResourcesLocally } = useAppResources();
  const { isLoading: profileLoading } = useUserProfile();

  const stelline = isObject(appResources?.stelline) ? appResources.stelline : null;
  const stellineBalance = Number.isInteger(stelline?.balance) ? stelline.balance : 0;

  const setStellineData = useCallback((updatesOrUpdater) => {
    updateAppResourcesLocally((currentResources) => {
      const currentStelline = isObject(currentResources?.stelline)
        ? currentResources.stelline
        : {};
      const updates = typeof updatesOrUpdater === 'function'
        ? updatesOrUpdater(currentStelline)
        : updatesOrUpdater;
      if (!isObject(updates)) {
        return { stelline: currentStelline };
      }
      return {
        stelline: {
          ...currentStelline,
          ...updates,
        },
      };
    });
  }, [updateAppResourcesLocally]);

  const value = useMemo(() => ({
    stelline,
    stellineBalance,
    isLoading: profileLoading,
    setStellineData,
  }), [
    stelline,
    stellineBalance,
    profileLoading,
    setStellineData,
  ]);

  return (
    <StellineContext.Provider value={value}>
      {children}
    </StellineContext.Provider>
  );
};
